declare var Highcharts: any;
export class Utils{

    //static rangeColor: string  = '#C7C7C7';
    static monthsInYear: any = {
        'Jan': 'January',
        'Feb': 'February',
        'Mar': 'March',
        'Apr': 'April',
        'May': 'May',
        'Jun': 'June',
        'Jul': 'July',
        'Aug': 'August',
        'Sep': 'September',
        'Oct': 'October',
        'Nov': 'November',
        'Dec': 'December',
        'jan': 'January',
        'feb': 'February',
        'mar': 'March',
        'apr': 'April',
        'may': 'May',
        'jun': 'June',
        'jul': 'July',
        'aug': 'August',
        'sep': 'September',
        'oct': 'October',
        'nov': 'November',
        'dec': 'December'
    };

    static monthsInYearNumbers: any = {
        'jan': 1,
        'feb': 2,
        'mar': 3,
        'apr': 4,
        'may': 5,
        'jun': 6,
        'jul': 7,
        'aug': 8,
        'sep': 9,
        'oct': 10,
        'nov': 11,
        'dec': 12
    };

    static areaPlotColors: any = {
        current : "#0096d7",
        previous: "rgb(93,151,50)",
        range : "#C7C7C7",
        average: Highcharts.eia_grey
    }

    static regionCodes: any = {
        "NW2_EPG0_SWO_R31_BCF" : 'East',
        "NW2_EPG0_SWO_R32_BCF" : 'Midwest',
        "NW2_EPG0_SWO_R33_BCF" : 'South Central',
        "NW2_EPG0_SNO_R33_BCF" : 'South Central Nonsalt',
        "NW2_EPG0_SSO_R33_BCF" : 'South Central Salt',
        "NW2_EPG0_SWO_R34_BCF" : 'Mountain',
        "NW2_EPG0_SWO_R35_BCF" : 'Pacific',
        "NW2_EPG0_SWO_R48_BCF" : 'Lower 48'
    };

    static regionColors: any = {
        "NW2_EPG0_SWO_R31_BCF" : Highcharts.eia_green,
        "NW2_EPG0_SWO_R32_BCF" : Highcharts.eia_yellow,
        "NW2_EPG0_SWO_R33_BCF" : Highcharts.eia_dk_blue,
        "NW2_EPG0_SNO_R33_BCF" : Highcharts.eia_dk_blue,
        "NW2_EPG0_SSO_R33_BCF" : Highcharts.eia_dk_blue,
        "NW2_EPG0_SWO_R34_BCF" : Highcharts.eia_red,
        "NW2_EPG0_SWO_R35_BCF" : Highcharts.eia_tan,
        "NW2_EPG0_SWO_R48_BCF" : Highcharts.eia_grey
    };

    static getWeek(d){
        // Returns the ISO week of the date.

        var date = new Date(d.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getUTCFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
            - 3 + (week1.getDay() + 6) % 7) / 7);
    }


    // returns date as MMM DD
    static getMonths(){
        return ['Jan','Feb','Mar','Apr','May', 'Jun', 'Jul','Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    }

  /**
   * @name oracleDateStringToDate
   * @methodOf Utils
   * @static
   * @description Takes a date string in the default Oracle format (DD-MMM-YYYY, ex. 3-MAR-2018) and converts it into a
   * javascript date.
   * @param {string} Date string to convert into a javascript date. In the format (DD-MMM-YYYY, ex. 3-MAR-2018).
   * @returns {Date} passed string as a javascript Date object.
   */
    static oracleDateStringToDate(dateString) {
        let dateStringParts = dateString.split('-');
      dateStringParts[1] = dateStringParts[1].toLowerCase();
      dateStringParts[1] = dateStringParts[1].substr(0, 1).toUpperCase() + dateStringParts[1].toLowerCase().substr(1,2);
        let m = this.getMonths().indexOf(dateStringParts[1]) + 1;
        let d = dateStringParts[0];
        let yy = dateStringParts[2];

        return new Date(m + '/' + d + '/' + yy);
    }


  /**
   * @name dateAsOracleDateString
   * @methodOf Utils
   * @static
   * @description Takes a date and returns it as a string in the default Oracle format (DD-MMM-YYYY, ex. 3-MAR-2018)
   * @param {Date} javascript Date object
   * @returns {string} Date string in the format (DD-MMM-YYYY, ex. 3-MAR-2018).
   */
    static dateAsOracleDateString(date) {
      let d = date.getUTCDate().toString();
      d = d < 10 ? '0' + d : d;
      return d + '-' + this.getMonths()[date.getUTCMonth()].toUpperCase() + '-' + date.getUTCFullYear();
    }

    static dateAsMMMDD(date){
       var dateArr = date.toUTCString().split(" ");
        var newDate = dateArr[2] + " " +  dateArr[1];
        return newDate;
    }

    static dateAsDDMMMYY(date){ //dd-mmm-yy
        var dateArr = date.toUTCString().split(" ");
        var newDate = dateArr[1] + "-" +  dateArr[2].toUpperCase() + "-" + dateArr[3].substring(2,4);
        return newDate;
    }

    static getDaysBetweenDates(startDate, endDate){
        var one_day=1000*60*60*24;
        var numberOfdays = endDate.getTime() - startDate.getTime();
        var daysBetween = Math.floor(numberOfdays/one_day);
        return daysBetween;

    }
    static dateAsMM(date){
        var dateArr = date.toUTCString().split(" ");
        var newDate = dateArr[2];
        return newDate;
    }
    static dateAsPlainString(date){ // ex. February 05, 1942
        var dateArr = date.toUTCString().split(" ");
        var newDate = this.monthsInYear[dateArr[2]] + " " +  dateArr[1] + ", " + dateArr[3];
        return newDate;
    }
    static numberWithComma(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}



// WEBPACK FOOTER //
// ./src/app/share-modules/Utils.ts